export default {
	messages: {
		de: {
			itemsPerPage: 'Einträge pro Seite',
			of: 'von',
			actions: {
				close: 'Schliessen',
				save: 'Speichern',
				cancel: 'Abbrechen',
				yes: 'Ja',
				no: 'Nein',
			},
		},
		en: {
			itemsPerPage: 'Rows per Page',
			of: 'of',
			actions: {
				close: 'Close',
				save: 'Save',
				cancel: 'Cancel',
				yes: 'Yes',
				no: 'No',
			},
		},
	},
};
